import { Dialog, DialogParams } from "@app/core/dialog/domain/dialog";
import { Section } from "@app/core/match/domain/model/section";
import { Statistics } from "@app/core/statistics/domain/model/statistics";

interface MarketingMessageParams extends DialogParams {
  show: boolean;
}

/*
  This class is used to recived the backend data to open
  a marketing dialog.
*/
export class MarketingMessage extends Dialog {
  /* Required: Should dialog be shown to the user */
  show: boolean;

  constructor(params: MarketingMessageParams) {
    super(params);
    this.show = params.show;
  }
}
